import Storage, { utf8ToB64 } from './storage'

const CURRENT_USER_STORAGE_KEY = utf8ToB64('current_user')
const TOKENS_STORAGE_KEY = utf8ToB64('tokens')
export default {
  user: new Storage(CURRENT_USER_STORAGE_KEY),
  tokens: new Storage(TOKENS_STORAGE_KEY),
}
